import styled from "styled-components";
import { Check } from "@styled-icons/fa-solid/Check";

interface StepProps {
  $active: string;
}

export const StepsFlowBox = styled.div`
  display: flex;
  height: 52px;
  border-radius: 17px;
  justify-content: space-between;
  width: 100%;
  padding-right: 2rem;
  padding-left: 2rem;
  z-index: 10;

  @media (max-width: 450px) {
    padding-right: 1rem;
    padding-left: 1rem;
    justify-content: center;
  }
`;

export const StepsTitle = styled.div`
  display: none;

  @media (max-width: 450px) {
    display: block;
  }
`;

export const Step = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #acb2c3;
`;

export const Circle = styled.div<StepProps>`
    min-width: 19px;
    height: 19px;
    border-radius: 100%;
    margin-right: 5px;
    padding-top: 1px;
    background: ${props => props.$active ? props.theme.colors.red7 : props.theme.colors.gray10} 0% 0% no-repeat padding-box;
    color: white;
    display: grid;
    place-items: center;
    font-size: 12px;
    font-weight: ${props => props.theme.fontWeight.textMedium};
    margin-top: ${props => props.$active ? '1px' : ''};
`;

export const StepText = styled.span<StepProps>`
    font-weight: ${props => props.$active ? props.theme.fontWeight.textBold : props.theme.fontWeight.textRegular};
    color: ${props => props.$active ? '' : props.theme.colors.lowEmphasisTextPlaceholder};
    margin-top: ${props => props.$active ? '3px' : ''};
    @media (max-width: 450px) {
      display: none;
    }
`;

export const CheckedStep = styled(Check)`
  width: 9px;
  path {
    color: white;
  }
`;
